<template>
  <div class="modal-form">
    <b-modal :id="id" :size="size" hide-footer centered>
      <div class="col-12 d-flex flex-column align-items-center">
        <img
          class="img-warning-modal mb-4"
          src="@/assets/images/icons/warning_.svg"
          width="15%"
        />
        <div class="title-modal-confirm font-weight-bold">{{ title }}</div>
        <AlertGeneral
          :icon="iconAlert"
          :variant="variantAlert"
          :text="textAlert"
          v-if="!eliminarRegistro"
        ></AlertGeneral>
        <slot></slot>
      </div>
    </b-modal>
  </div>
</template>
<script>
import AlertGeneral from "@/components/core/alert/alert-general.vue";
export default {
  name: "confirm-modal",
  components: { AlertGeneral },
  props: {
    id: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
    size: {
      default: "",
      type: String,
    },
    textAlert: {
      default: "",
      type: String,
    },
    variantAlert: {
      default: "",
      type: String,
    },
    iconAlert: {
      default: false,
      type: Boolean,
    },
    eliminarRegistro: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["click_guardar_emit", "click_cancelar_emit"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.title-modal-confirm {
  font-weight: 500;
  font-size: 21px;
  line-height: 24px;

  text-align: center;

  color: #263238 !important;
}

.modal-header .close {
  font-weight: 500;
  font-size: 32px;
  text-transform: uppercase;
  color: blue;
}

.img-warning-modal {
  width: auto;
  height: auto;
}

.img-alert-modal {
  width: 20px;
}

.text-alert-modal {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;

  color: #263238;
}
</style>